'use client';

import { createContext, useContext } from 'react';
import { ELanguage } from '../Utils/constants.js';

var MultiLevelSelectContext = createContext({
    values: [],
    options: [],
    onChange: function () { },
    fieldKey: '',
    fieldValue: '',
    floatingConfig: {},
    onBlur: function () { },
    dropdown: {},
    placeholder: '',
    langCode: ELanguage.VI,
    translate: function () { return ''; },
    hasError: false,
    separate: ''
});
var useMultiLevelContext = function () { return useContext(MultiLevelSelectContext); };

export { MultiLevelSelectContext, useMultiLevelContext };
//# sourceMappingURL=store.js.map
